export default __webpack_public_path__ + "static/media/11.5f1396b7.png";